import React, {  useState } from "react";
import styles from "./OrganisationTable.module.scss";
import { useQuery } from "@apollo/client";
import { ORGANISATIONS } from '../../apollo/queries';
import { NavLink } from 'react-router-dom';
import {OrganisationTableRow } from './types';
import { Field, Formik } from 'formik';
import { Input } from '../common/Input';
import DataTable from 'react-data-table-component';
import { customStyles } from '../DataTable/customStyles';
import columns from './columnDefs';
import { Button } from '../common/Button';
import moment from 'moment';

const initialFormValues = {
    search: "",
};

// @ts-ignore
const mapData = (data) => {
    console.log(data)
    // @ts-ignore
    return data.organisations.map((row) => {
        let parentName = row.parent ? row.parent.name : '-';
        return {
            id: row.id,
            companyParentName: parentName,
            organisationType: row.organisationType,
            companyName: row.name,
            contactPerson: row.contactPerson,
            founder: row.contact.name,
            foundingDate: row.foundingDate,
            sector: row.sector,
            website: row.website,
            createdAt: moment(row.createdAt).format('YYYY-MM-DD HH:mm'),
        }
    })
}

export const OrganisationTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);


  useQuery(ORGANISATIONS, {
    onCompleted: (someData) => {
      setLoading(false)
      setData(mapData(someData))
    },
    fetchPolicy: "no-cache"
  });

  const searchAction = (search: string) => {
      search = search.toLowerCase()

      const result = data.filter((row: OrganisationTableRow) => {
        // @ts-ignore
        return (
            row.companyName?.toLowerCase().includes(search)
            || row.companyParentName?.toLowerCase().includes(search)
            || row.contactPerson?.toLowerCase().includes(search)
            || row.founder?.toLowerCase().includes(search)
            || row.organisationType?.toLowerCase().includes(search)
            || row.foundingDate?.toLowerCase().includes(search)
            || row.sector?.toLowerCase().includes(search)
        )
      })

      setData(result)
  }

  return (
      <div className={styles.wrapper}>
          <div className={styles.createButtonDiv}>
              <NavLink to="/admin/organisations/create">
                  <Button className="dark" type="button">Create</Button>
              </NavLink>
          </div>
          <Formik
              initialValues={initialFormValues}
              onSubmit={(
                  values: {
                      search: string
                  },
              ) => {
                  const { search } = values;
                  searchAction(search);
              }}
          >
              {({ values, handleChange, handleSubmit }) => (
                  <form className={styles.formContainer} onSubmit={handleSubmit}>
                      <div className={styles.searchContainer}>
                          <Field
                              name="search"
                              as={Input}
                              type="text"
                              placeholder="Filter on..."
                              onChange={handleChange}
                              value={values.search}
                              // autoFocus
                          />
                          <span title="Reset" onClick={() => {
                              values.search = '';
                          }} className={styles.clearSearch}>X</span>
                          <button type="submit">
                              <img
                                  src="/assets/search.svg"
                                  width="20"
                                  height="20"
                                  alt="search"
                              />
                          </button>
                      </div>
                  </form>
              )}
          </Formik>
          <span className={styles.recordsSpan}>No. records: {data.length}</span>
          <br/>
          <div className={styles.main}>
              <DataTable
                  // @ts-ignore
                  customStyles={customStyles}
                  // @ts-ignore
                  columns={columns()}
                  data={data}
                  defaultSortFieldId="createdAt"
                  defaultSortAsc={false}
                  highlightOnHover
                  progressPending={loading}
                  noDataComponent={<div style={{ padding: '40px' }}>No records found</div>}
                  pagination
                  // rowKey="id"
                  fixedHeader={true}
                  fixedHeaderScrollHeight={'800px'}
              />
          </div>
      </div>
  )
};
